import { type Decisions, getAutoshipMaxSavings } from '@libs/common-next';
import { AUTOSHIP_RECURRING_ORDERS_DISCOUNT } from '@libs/core';
import {
    type GetAutoshipDiscountMessagesParams,
    getAutoshipDiscountMessages as getCrawlAutoshipDiscountMessages,
} from '@libs/shared-ui';

type Params = GetAutoshipDiscountMessagesParams & {
    autoshipFlag: Decisions['ff_autoship'];
};

/**
 * Precrawl keeps its legacy subtext; every other mode, and products without a discount display
 * (MAP restricted), use the shared crawl copy.
 */
export const getAutoshipDiscountMessages = ({ autoshipFlag, ...params }: Params) => {
    const { discountDisplay, isFirstAutoshipEligible } = params;

    if (autoshipFlag !== 'precrawl' || !discountDisplay?.trim()) {
        return getCrawlAutoshipDiscountMessages(params);
    }

    const displayDiscount = isFirstAutoshipEligible ? discountDisplay : AUTOSHIP_RECURRING_ORDERS_DISCOUNT;
    const maxDiscount = getAutoshipMaxSavings();
    const subtextMessage = isFirstAutoshipEligible
        ? `Save ${displayDiscount} on your first order and ${AUTOSHIP_RECURRING_ORDERS_DISCOUNT} on future orders (up to ${maxDiscount})`
        : `Save ${displayDiscount} on future orders (up to ${maxDiscount})`;

    return {
        autoshipDiscountHeader: `Autoship & save ${displayDiscount}`,
        autoshipDiscountSubtext: subtextMessage.replace(/ {2,}/g, ' '),
        autoshipDiscountSubtextTwo: undefined,
    };
};
